import React, { Component } from "react";

import WidgetTable from "./../../widget/WidgetTable";
import WidgetInput from "./../../widget/WidgetInput";
import { AddButton, GeneralButton } from "./../../widget/WidgetButton";

import './../../css/frame.css';
import './../../css/project.css';
import './demo.scss';
// import './demo.css';

class Demo extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            columns: [
                { name: 'ID', title: 'ID对象ID', type: 'string', description: '对象ID', properties: { hidden: true }},
                { name: 'NAME', title: '数据中心名称', type: 'string', description: '数据中心名称', properties:{click:"onDataNameClick"}},
                { name: 'DOM', title: '归属行政区划', type: 'string', description: '归属行政区划', },
                { name: 'NUM', title: '资源总数', type: 'string', description: '资源总数', },
                { name: 'UP_TIME', title: '更新时间', type: 'string', description: '更新时间', },
                { name: 'CREAT_TIME', title: '创建时间', type: 'string', description: '创建时间', },
                { name: 'DEC', title: '描述', type: 'string', description: '描述', },
                {name: "operation",title: "操作", type: "string", description: "操作", properties: {
                    operations: [
                      { name: "编辑", click: "edit" },
                      { name: "删除", click: "remove" },
                    ]},
                },
            ],
            data: [
                {ID: 1, NAME: '数据中心1', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 2, NAME: '数据中心2', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 3, NAME: '数据中心3', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 4, NAME: '数据中心4', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 5, NAME: '数据中心5', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 6, NAME: '数据中心6', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 7, NAME: '数据中心', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 8, NAME: '数据中心', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
                {ID: 9, NAME: '数据中心', DOM: '北京', UP_TIME: '2022-06-23', CREAT_TIME: '2022-06-22', DEC: '描述描述描述描述描述'},
            ],
            total: 0,
            tableOptions : {
                records : 10, 
                check: {
                    key: 'ID',
                    enable: true
                }
            }
        }
    }

    render()
    {

        const {columns, tableOptions, total, data} = this.state;

        return (
            <div data-component="demo">
                <div className="sfm-page sfm-box-shadow spj-page spg-page">
                    <div className="sfm-page-title spj-page-title">
                        首页
                    </div>

                    <div className="sfm-flex-between sfm-padding-btm20">

                        <div className="sfm-page-title spj-page-title">
                            首页
                        </div>

                        <div className='sfm-filter'>
                            <WidgetInput placeholder="请输入你需要搜索的内容" onChange={(e)=>{this.setState({keyWord: e.target.value})}} onKeyUp={this.onKeyUp}/>
                            
                            <AddButton onClick={this.add} text='新增数据中心'/>
                            <GeneralButton onClick={this.batchRemove} text='删除'/>
                        </div> 
                    </div>

                    <div className='sfm-content'>
                        <div className="sfm-content-title spj-content-title spg-content-title">
                            正文示例
                        </div>
                        <WidgetTable columns={columns} options={tableOptions} data={data} total={total} notify={this.notify} pageTurning={this.pageTurning}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default Demo
